import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-24 right-8 z-50 bg-[#1A1A1A] border border-[#2A2A2A] text-white/60 hover:text-white hover:border-[#FF0000] p-3 transition-all duration-300 hover:scale-110"
      aria-label="Retour en haut"
      data-testid="back-to-top"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
